import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, Spinner } from 'reactstrap';
import { SeatCountStorageKey } from '../../../constants/localStorage';
import { setUpUser } from '../../../utilities/orgPanelApiCalls';
import { errorToast } from '../../../constants/toast';
import { useAPIContext } from '../../../utilities/Contexts/DCGAutomationPagesContextProvider';
import DCGToastMessage  from '../../../components/ToastMessage/DCGToastMessage';
import { getAutomationDataFromLocalStorage, markAutomationCompleted } from '../../../utilities/getAutomationDataFromLocalStorage';
import { useNavigate } from "react-router-dom";
import { DcgAutomation } from '../../../constants/onboardingVersions';
import { useStore, toastToggleCallback, makeToast } from '../../../utilities/appStore';

const CreateSubscriptionPageContent = () => {
    const DEVICE_COST = 15; // Assume $15 per device per month
    const SUBSCRIPTION_LIST_LENGTH = 100;

    const navigate  = useNavigate();
    const { navigateToPage } = useAPIContext();
    const [numDevices, setNumDevices] = useState(() => {
        const numDevices = localStorage.getItem(SeatCountStorageKey);
        return numDevices || 0;
    });
    let toast = useStore((state) => state.toast);
    useEffect(() => {
        localStorage.setItem(SeatCountStorageKey, numDevices);
    }, [numDevices]);

    const [isLoading, setIsLoading] = useState(false);

    const handleDeviceChange = (e) => {
        setNumDevices(parseInt(e.target.value, 10));
    };
    
    const handleSubmit = (event, buttonType) => {
        event.preventDefault();

        async function submit() {
            setIsLoading(true);
            let dataModel = getAutomationDataFromLocalStorage();
            if (!dataModel) {
                setIsLoading(false);
                navigateToPage("selectRole");
                return;
            }
            dataModel.seatCount = numDevices;
            dataModel.isTraditional = false;
            dataModel.isDcgAutomation = true;
            if (buttonType === 'skip') {
                dataModel.seatCount = 0;
            }
            var result = await setUpUser(dataModel);
            setIsLoading(false);
            if (result.status > 299) {
                let errorData = '';
                if (typeof (result.data) === 'string') {
                    errorData = result.data.substring(0, 100);
                }
                makeToast(`Failed to process the request. ${errorData}`, errorToast);
            }
            if (result.status <= 299) {
                if (buttonType === 'skip') {
                    markAutomationCompleted(`/${DcgAutomation}/subscriptionConfirmationNoLicense`);
                    navigate(`/${DcgAutomation}/subscriptionConfirmationNoLicense`);
                } else {
                    if (result.data) {
                        window.location.href = result.data;
                    } else {
                        makeToast('No redirect URL found. You might already have an account', errorToast);
                    }
                }
            }
        } submit();
    }
    return (
        <>
            {toast?.display && <DCGToastMessage isOpen={true} Message={toast?.message} Type={toast.type} ToggleCallback={toastToggleCallback} />}
            {!isLoading && <Container className="text-center">
                {/* Form */}
                <Form onSubmit={(event) => handleSubmit(event, 'submit')}>
                    <FormGroup>
                        <Row className="justify-content-center">
                            <Col xs="auto">
                                <Label for="deviceSelect">Number of devices:</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    bsSize="sm"
                                    type="select"
                                    name="devices"
                                    id="deviceSelect"
                                    value={numDevices}
                                    onChange={handleDeviceChange}
                                >
                                    {[...Array(SUBSCRIPTION_LIST_LENGTH).keys()].map((num) => (
                                        <option key={num} value={num}>
                                            {num}
                                        </option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                <p>Number of licenses available: {numDevices}</p>
                            </Col>
                        </Row>

                        {/* Price Calculation */}
                        <Row className="justify-content-center my-3">
                            <Col>
                                <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                                    <strong>{numDevices} Device License{numDevices > 1 ? 's' : ''} (${DEVICE_COST} each / per month)</strong>
                                    <p className="mb-0">
                                        <strong>Total: ${numDevices * DEVICE_COST} / month*</strong>
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col className='text-sm'>
                                *cost estimate above excludes any discounts or custom pricing.
                            </Col>
                        </Row>

                        {/* Buttons */}
                        <Row className="justify-content-center my-4">
                            <Col xs="auto">
                                <Button disabled={!numDevices} type="submit" color="primary">Start Subscription</Button>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col xs="auto">
                                <Button color="link" onClick={(event) => handleSubmit(event, 'skip')} className="text-muted">Skip this step</Button>
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
            </Container>}
            {isLoading && <Spinner className="centered-onboarding-loader" />}
        </>
    );
}

export default CreateSubscriptionPageContent;